/*
 * @Author: Girish Akhare
 * @Date: 2022-01-21 10:48:11
 * @Last Modified by: Girish Akhare
 * @Last Modified time: 2022-07-18 19:22:19
 */
import { ElementRef } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'custom-dnd-file',
  templateUrl: 'dnd-file.component.html',
  styleUrls: ['./dnd-file.component.scss']
})
export class CustomDndFileComponent implements OnInit {
  @Input()
  maxFiles = -1;

  @Input()
  acceptFile = '*';

  files: any[] = [];

  @Input()
  isDisable = false;

  @Output()
  change = new EventEmitter();

  isInvalidFileFormat = false;

  @ViewChild('fileDropRef', { static: true })
  fileDropRef: ElementRef;

  uploadeFiles: any[] = [];

  constructor() {}

  ngOnInit(): void {}
  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
    this.fileDropRef.nativeElement.value = '';
    this.disableOnMaxReach();
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    this.isInvalidFileFormat = false;
    this.uploadeFiles = files;
    if (!this.isDisable) {
      if (files[0].name.includes('.csv') || files[0].name.includes('.xls')) {
        for (const item of files) {
          item.progress = 0;
          this.files.push(item);
        }
        this.disableOnMaxReach();
        files[0].progress = 100;
        this.change.emit();
      } else {
        this.isInvalidFileFormat = true;
      }
    }
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  /**
   * Disable input when max file reaced
   */
  disableOnMaxReach() {
    this.isDisable = Number(this.maxFiles) === this.files.length;
  }
}
